const { useState, useEffect } = wp.element;

import { Bar } from 'react-chartjs-2';

import Error from './error';
import { numberWithCommas } from './helpers';
import { getActivityPerMinutes, getRealtimeActivity } from './analytics';

const CSS = {
  activeNow: {
    textAlign: 'center',
    fontSize: '34px',
    color: '#007cba',
    marginBottom: '10px',
    lineHeight: '20px'
  }
};

const Realtime = (props) => {
  const [ viewId, setViewId ] = useState(null);
  const [ error, setError ] = useState();
  const [ visible, setVisible ] = useState(false);
  const [ dataIsOld, setDataIsOld ] = useState(true);
  const [ activityPerMinutes, setActivityPerMinutes ] = useState();
  const [ currentActivity, setCurrentActivity ] = useState();

  const onRefresh = async () => {
    try {
      if (viewId) {
        const [ perMinutes, activity ] = await Promise.all([ getActivityPerMinutes(viewId), getRealtimeActivity(viewId) ]);
        setDataIsOld(false);
        setActivityPerMinutes(perMinutes);
        setCurrentActivity({ users: activity.users, pages: activity.pages });
        setTimeout(() => setDataIsOld(true), 10000);
      }
    } 
    catch (err) {
      setError(err);
      console.log(err);
    }
  };

  const chartOptions = {
    animate: false,
    legend: { display: false },
    scales: {
      xAxes: [{
        categoryPercentage: 1.0,
        barPercentage: 1.0
      }],
      yAxes: [{ 
        ticks: { callback: (value) => numberWithCommas(value) } 
      }]
    },
    tooltips: {
      callbacks: { label: (item) => ' ' + numberWithCommas(item.value) }
    }
  };

  // Effects
  useEffect(() => setViewId(props.viewId), [ props.viewId ]);
  useEffect(() => setVisible(props.visible), [ props.visible ]);
  useEffect(() => {
    if (!error && viewId && visible && dataIsOld) {
      onRefresh();
    }
  }, [ error, viewId, visible, dataIsOld ]);

	return visible ? (
    <div class='meow-analytics-dashboard-block'>

      {/* Display errors */}
      <Error error={error} reset={() => setError(null)} />

      {/* Display chart */}
      {!error && currentActivity && activityPerMinutes &&
        <div>
          <div style={CSS.activeNow}>{currentActivity.users}<br />
            <small style={{ fontSize: '14px' }}>active users on site</small>
          </div>
          <div>            
            <div style={{ marginBottom: '10px' }}><Bar data={activityPerMinutes} options={chartOptions} /></div>
            <table style={{ marginBottom: '10px' }} class="wp-list-table widefat striped">
              <thead><tr><td>Page</td><td style={{ width: '40px' }}>Users</td></tr></thead>
              <tbody>{currentActivity.pages?.map(x => <tr><td>{x.page}</td><td>{x.users}</td></tr> )}</tbody>
            </table>
          </div>
        </div>
      }

    </div>
  ) : null;
}

export default Realtime;